import { type TextFieldProps } from "@mui/material/TextField";
import type { CustomInputProps } from "@components/Input/Input.types.ts";
import { TextField } from "./Input.styles";

const Input: React.FC<CustomInputProps & TextFieldProps> = ({ testId, slotProps, ...rest }) => {
  return (
    <TextField
      {...rest}
      slotProps={{
        ...slotProps,
        htmlInput: {
          ...slotProps?.htmlInput,
          "data-testid": testId,
        },
      }}
    />
  );
};

export default Input;
